import "./listing-progressbar.css";

interface VerificationProgressProps {
  progress?: number; // 0-100
  progressStatus?: string;
  progressText?: string;
}

export default function VerificationProgress({
  progress = 12,
  progressText = "Progress",
  progressStatus = "",
}: VerificationProgressProps) {
  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(Math.max(progress, 0), 100);

  // Always use 4 segments
  const segments = 4;

  // Calculate how much of each segment should be filled
  const segmentThreshold = 100 / segments;

  const renderSegments = () => {
    const segmentElements = [];

    for (let i = 0; i < segments; i++) {
      // Calculate fill percentage for this segment
      const segmentStart = i * segmentThreshold;
      const segmentEnd = (i + 1) * segmentThreshold;

      let fillPercentage = 0;

      if (normalizedProgress >= segmentEnd) {
        // Segment is fully filled
        fillPercentage = 100;
      } else if (normalizedProgress > segmentStart) {
        // Segment is partially filled
        fillPercentage =
          ((normalizedProgress - segmentStart) / segmentThreshold) * 100;
      }

      segmentElements.push(
        <div key={i} className={"progressSegment"}>
          <div
            className={"progressFill"}
            style={{ width: `${fillPercentage}%` }}
          ></div>
        </div>,
      );
    }

    return segmentElements;
  };

  return (
    <div className={"listingProgressSection"}>
      <div className={"progressLabel"}>{progressText}</div>
      <div className="progress-status-container">
        <span className="listing-status-badge">{progressStatus}</span>

        <div className={"progressBarContainer"}>{renderSegments()}</div>
      </div>
    </div>
  );
}
